// removed by extract-text-webpack-plugin
module.exports = {"object-of-study":"_17B6w1Kbn5tAfsLLRuhQ8V"};